import axios from "axios";

export const deletePatientSessionRequest = async (): Promise<void> => {
  await axios.delete("/api/patient_sessions");
};
